import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  countries: [],
  banks: [],
};

export default function ConstantReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.CONSTANT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.CONSTANT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        countries: action.payload,
      };
    case types.FETCH_BANKS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        banks: action.payload,
      };
    default:
      return state;
  }
}
